// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1kMWK","title":"AfterBackImages_title__3mAbl","images":"AfterBackImages_images__3z5zy"};